import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';

import { AppContext } from '../context/AppContext';

const useRedirectIfNoTariffs = () => {
  const { recommendedTariffs } = useContext(AppContext);
  const history = useHistory();

  useEffect(() => {
    if (!recommendedTariffs?.length) {
      history.push('/app/tariffs');
    }
  }, [recommendedTariffs, history]);
};

export default useRedirectIfNoTariffs;
